<template>
    <div class="content-wrap">
        <h4 class="title-group">调用计划规格</h4>
        <div class="tree-chart-wrap" v-loading="sourcePlanLoading">
            <div class="tree-chart" id="sourceChart" :style="{height:sourceIdeaNum>5?(150+12*sourceIdeaNum)+'px':'150px'}"></div>
        </div>

        <div class="mb20">
            <h4 class="title-group inline-block mr6">新计划规格预览</h4>
            <el-button type="primary" size="mini" class="mr6" @click="handlePopPreview" :disabled="previewLoading">规格预览/刷新</el-button>
            <span class="text-color-gray" v-if="previewResult.length>0">共{{previewResult.length}}种规格，如下：</span>
        </div>

        <div class="preview-list" v-loading="previewLoading">
            <div class="text-color-gray pl20 mt20 tac" :style="{width: '100%',lineHeight:'36px'}" v-if="previewResult.length<=0">暂无数据</div>
            <div class="" v-for="(item,index) in previewResult" :key="index+'pre'">
                <h4 class="title-group">规格{{index+1}}：共{{item.num}}套
                    <span v-if="item.same_source">（与调用计划规格一致）</span>
                </h4>
                <div class="tree-chart-wrap">
                    <div class="tree-chart" :id="'resultChart-'+index" :style="{height:item.idea_num>5?(150+12*item.idea_num)+'px':'150px'}"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import API from '@/api/marketManage/vivoBatch';

    export default {
        name: "IdeaSpecsPreview",
        props:{
            planId:{
                required:true,
                type:[String,Number],
            },
            taskId:{
                required:true,
                type:[String,Number],
            },
            target:{
                required:true,
                type:Array,
            },
            data:{
                required: true,
                type:Object,
            },
            config:{
                required:true,
                type:Array,
            },
            appData:{
                required: true,
                type:Array,
            },
            replaceNameStatus:[String,Number],
        },
        data(){
            return {
                sourceIdeaNum:1,
                sourcePlanLoading:false,
                sourcePlanConfig:[],
                sourceChart:null,
                previewLoading:false,
                previewResult:[],
                resultCharts:{},

            }
        },
        mounted(){
            window.addEventListener("resize", this.resizeChart);
        },
        watch:{
            previewLoading(val){
                this.$emit('preview',val);
            }
        },
        methods:{
            getSourcePlanConfig(){
                this.sourcePlanLoading = true;
                API.getSourcePlanConfig({
                    plan_id:this.planId,
                    task_id:this.taskId,
                }).then(res=>{
                    let resData = res.data||{};
                    this.sourcePlanLoading = false;
                    this.sourcePlanConfig = resData.config||[];
                    this.sourceIdeaNum = resData.idea_num||1;
                    this.$nextTick(()=>{
                        this.updateSourceChart();
                    });
                },err=>{
                    console.log('getSourcePlanConfig err',err);
                    this.$message.error(err.info||'操作失败');
                    this.sourcePlanLoading = false;
                });
                this.previewResult = []   // 2023/3/21  新增  (ys)
            },
            updateSourceChart(){
                let $sourceChart = document.getElementById('sourceChart');
                if(!$sourceChart) return;
                if(!this.sourceChart){
                    this.sourceChart = echarts.init($sourceChart);
                }
                let option = {
                    series:[this.getTreeBasicOptions()],
                };
                option.series[0].data = this.sourcePlanConfig||[];
                this.sourceChart.setOption(option,true);
                this.sourceChart.resize();
            },
            updatePreviewChart(){
                setTimeout(()=>{
                    this.previewResult.forEach((item,index)=>{
                        let chartName = 'resultChart-'+index;
                        let $resultChart = document.getElementById(chartName);
                        if(!$resultChart) return;

                        if(!this.resultCharts[chartName]){
                            this.sourceChart[chartName] = echarts.init($resultChart);
                        }
                        let option = {
                            series:[this.getTreeBasicOptions()],
                        };
                        option.series[0].data = item.config;
                        this.sourceChart[chartName].setOption(option,true);
                        this.sourceChart[chartName].resize();
                    })
                },100)
            },
            getTreeBasicOptions(){
                return {
                    type: 'tree',
                    silent: true,     // 节点是否可以点击展开
                    top: '5%' ,
                    left: '15%' ,
                    right: '25%',
                    data: [],
                    symbol: 'none',
                    edgeShape: 'polyline',
                    initialTreeDepth: 3,       // 默认展开的层级
                    lineStyle: {
                        curveness: 0,         // 连接线的曲度，0为直线
                        width: 1,
                    },
                    label: {            // 节点文字样式
                        position: 'left',
                        verticalAlign: 'middle',
                        align: 'right',
                        backgroundColor: '#fff',
                    },
                    leaves: {
                        label: {                 // 末节点文字样式
                            position: 'right',
                            verticalAlign: 'middle',
                            align: 'left',
                            backgroundColor: '#fff',
                        }
                    }
                }
            },
            handlePopPreview() {
              this.$emit('previewDom')
            },
            preview(groups, app_link_info){
                return new Promise((resolve,reject) => {
                    this.previewLoading = true;
                    this.previewResult = [];
                    for(let item in this.resultCharts){
                        this.resultCharts[item].dispose();
                    }
                    API.taskPreview({
                        target_account:this.target.join(','),
                        task_id:this.taskId,
                        package_name:(this.appData||[]).map(item=>item.package_name),
                        groups: groups,
                        replace_name_status:this.replaceNameStatus,
                        app_link_info
                    }, {timeout: 120 * 1000}).then(res=>{
                        console.log('taskPreview',res);
                        this.previewLoading = false;
                        let resData = res.data||{};
                        this.previewResult = resData.list||[];
                        this.$nextTick(()=>{
                            this.updatePreviewChart();
                        });
                        resolve(resData);
                    },err=>{
                        let errData = err.data||[];
                        if(err.code==0&&errData.length>0){
                            let text = errData.map(item=>`<p style="text-align: initial;">${item}</p>`).join('')
                            this.$notify.error({
                                title: err.info||'请求失败',
                                dangerouslyUseHTMLString: true,
                                message: text,
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'操作失败');
                        }

                        this.previewLoading = false;
                        reject();
                    })
                });
            },
            destroyCharts(){
                if(this.sourceChart) {
                    this.sourceChart.dispose();
                }
                for(let item in this.resultCharts){
                    this.resultCharts[item].dispose();
                }
            },
            _formatSubmitData(){
                /* 格式化成后端需要的格式 */
                let oData = this.data||{};
                let groupNames = Object.keys(oData);    // [5447945-1-10000-62]
                let result = {};
                groupNames.forEach((item)=>{
                    result[item] = {};
                    oData[item].forEach((inner,innerIndex)=>{
                        let keyIndex = (innerIndex+1)+'';
                        let dataItem = oData[item][innerIndex];
                        // 2023/3/21 去除空素材提交预览
                        if( dataItem && !Object.values(dataItem).every(i=>i===null)){
                            result[item][keyIndex] = Object.keys(dataItem).map(item=>{
                                let innerItem = dataItem[item]||{}
                                return {
                                    value_name:item,
                                    material_name:innerItem.material_name,
                                    material_url:innerItem.material_url,
                                }
                            });
                        }
                    })
                });
                return result;
            },
            resizeChart(){
                if(this.sourceChart) {
                    this.sourceChart.resize();
                }
                for(let item in this.resultCharts){
                    this.resultCharts[item].resize();
                }
            },
        },
        beforeDestroy() {
            this.destroyCharts();
            window.removeEventListener("resize", this.resizeChart);
        },
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        width: 100%;
        height: 100%;
        max-height: 550px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .tree-chart-wrap{
        background-color: #fff;
        min-height: 100px;
        border-radius: 4px;
        margin: 10px 0;
        .tree-chart{
            height: 100px;
        }
    }
    .title-group{
        line-height: 16px;
    }
    .preview-list{
        min-height: 100px;
        background-color: #f2f2f2;
    }
</style>
